<template>
  <v-app class="wisata-app">
    <v-app-bar
      app
      flat
      color="white"
      light
      height="70"
      class="main-header border-bottom-light"
    >
      <div class="d-flex align-center w-100 px-2">
        <v-btn icon class="back-btn mr-2" aria-label="Kembali" @click="goBack">
          <v-icon color="#1e293b">mdi-arrow-left</v-icon>
        </v-btn>

        <v-avatar color="rgba(1, 140, 116, 0.1)" size="40" class="mr-3 rounded-lg">
          <v-icon color="#018c74" size="24">mdi-layers-outline</v-icon>
        </v-avatar>
        <div>
          <h1
            class="text-subtitle-1 font-weight-bold primary-text mb-0"
            style="line-height: 1.2"
          >
            {{ currentCategoryName }}
          </h1>
          <p class="text-caption text-secondary mb-0">
            Jelajahi destinasi pilihan di Bondowoso
          </p>
        </div>
      </div>
    </v-app-bar>

    <v-main class="main-content-layout">
      <v-container fluid class="pa-4 fill-height-container">
        <v-row class="fill-height-row" no-gutters>
          <v-col cols="12" md="4" lg="3" class="pr-md-3 fill-column">
            <v-card class="sidebar-layout-card d-flex flex-column" flat rounded="lg">
              <div class="sidebar-top-pane pa-4 pb-2">
                <h2 class="text-subtitle-2 font-weight-bold mb-3 primary-text">
                  Daftar {{ currentCategoryName }}
                </h2>

                <v-text-field
                  v-model="searchQuery"
                  placeholder="Cari..."
                  outlined
                  dense
                  hide-details
                  clearable
                  color="#018c74"
                  class="search-field"
                >
                  <template v-slot:prepend-inner>
                    <v-icon color="grey lighten-1" size="20" class="mr-1"
                      >mdi-magnify</v-icon
                    >
                  </template>
                </v-text-field>
              </div>

              <div class="sidebar-scroll-content flex-grow-1 overflow-y-auto px-4 py-2">
                <div
                  v-if="filteredSub.length === 0"
                  class="text-center py-8 text-caption text-secondary"
                >
                  <v-icon color="grey lighten-1" size="32" class="mb-2"
                    >mdi-map-marker-off</v-icon
                  >
                  <div>Tidak ada hasil untuk "{{ searchQuery }}"</div>
                </div>

                <v-card
                  v-for="sub in filteredSub"
                  :key="sub.id"
                  :class="[
                    'wisata-item-card mb-3',
                    { 'active-item': activeSubId === sub.id },
                  ]"
                  outlined
                  flat
                  rounded="lg"
                  @click="selectWisata(sub)"
                >
                  <v-row no-gutters class="pa-2 flex-nowrap" align="center">
                    <v-col cols="3" class="flex-grow-0 flex-shrink-0">
                      <v-img
                        :src="
                          sub.full_url && sub.full_url !== ''
                            ? sub.full_url
                            : '/images/defaulttenant.png'
                        "
                        aspect-ratio="1"
                        class="rounded-lg"
                        cover
                      ></v-img>
                    </v-col>

                    <v-col
                      class="pl-3 py-1 d-flex flex-column justify-center overflow-hidden"
                    >
                      <h3
                        class="text-caption font-weight-bold primary-text text-truncate mb-0"
                      >
                        {{ sub.nama_sub }}
                      </h3>
                      <div class="d-flex align-center location-tag mt-1">
                        <v-icon x-small color="#018c74" class="mr-1"
                          >mdi-map-marker</v-icon
                        >
                        <span
                          class="text-overline text-secondary text-truncate"
                          style="
                            font-size: 0.65rem !important;
                            transform: none;
                            letter-spacing: 0;
                          "
                          >Bondowoso, Jawa Timur</span
                        >
                      </div>
                    </v-col>

                    <v-col cols="auto" class="pl-2 flex-grow-0 flex-shrink-0">
                      <v-btn
                        icon
                        small
                        color="#018c74"
                        class="action-route-btn"
                        @click.stop="goToTenants(sub)"
                      >
                        <v-icon small>mdi-arrow-right-circle</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card>
              </div>

              <div class="sidebar-bottom-pane pa-4 pt-2">
                <v-btn
                  block
                  depressed
                  disabled
                  color="#f8fafc"
                  class="text-capitalize font-weight-bold rounded-lg primary-text"
                  style="
                    background-color: #f8fafc !important;
                    color: #1e293b !important;
                    opacity: 1;
                  "
                >
                  <v-icon left small color="#018c74">mdi-layers-triple-outline</v-icon>
                  {{ filteredSub.length }} Sub Kategori
                </v-btn>
              </div>
            </v-card>
          </v-col>

          <v-col cols="12" md="8" lg="9" class="pl-md-1 fill-column d-flex flex-column">
            <v-card class="map-container-card flex-grow-1 mb-3" flat rounded="lg">
              <div id="map" class="map-inner-display"></div>
            </v-card>

            <v-card
              v-if="selectedWisataData"
              class="detail-display-card pa-4"
              flat
              rounded="lg"
            >
              <v-row no-gutters>
                <v-col cols="12" sm="4" md="3" class="pr-sm-4 mb-3 mb-sm-0">
                  <v-img
                    :src="
                      selectedWisataData.full_url && selectedWisataData.full_url !== ''
                        ? selectedWisataData.full_url
                        : '/images/defaulttenant.png'
                    "
                    class="rounded-lg detail-preview-img"
                    height="100%"
                    max-height="150"
                    contain
                  ></v-img>
                </v-col>
                <v-col
                  cols="12"
                  sm="8"
                  md="9"
                  class="d-flex flex-column justify-space-between"
                >
                  <div>
                    <div class="d-flex align-center justify-space-between">
                      <h2 class="text-h6 font-weight-bold primary-text mb-0">
                        {{ selectedWisataData.nama_sub }}
                      </h2>
                      <v-btn
                        small
                        depressed
                        color="#018c74"
                        class="white--text text-capitalize rounded-lg"
                        @click="goToTenants(selectedWisataData)"
                      >
                        Buka Daftar {{ currentCategoryName }}
                        <v-icon right small>mdi-chevron-right</v-icon>
                      </v-btn>
                    </div>
                    <div class="d-flex align-center mb-2 mt-1">
                      <v-icon small color="#018c74" class="mr-1">mdi-map-marker</v-icon>
                      <span class="text-caption text-secondary font-weight-medium"
                        >Bondowoso, Jawa Timur</span
                      >
                    </div>
                    <p class="text-caption text-secondary mb-3 info-paragraph-text">
                      {{ selectedWisataData.nama_sub }} merupakan salah satu destinasi
                      unggulan dalam kategori {{ currentCategoryName }}. Tempat ini
                      menyajikan pengalaman istimewa yang wajib dikunjungi saat berada di
                      Kabupaten Bondowoso.
                    </p>
                  </div>

                  <div class="specs-horizontal-grid pt-2 border-top-light">
                    <v-row no-gutters class="text-left">
                      <v-col cols="6" sm="3" class="d-flex align-center py-1">
                        <v-icon color="#018c74" size="20" class="mr-2"
                          >mdi-terrain</v-icon
                        >
                        <div>
                          <div
                            class="text-caption font-weight-bold primary-text mb-0"
                            style="line-height: 1.2"
                          >
                            Terbuka
                          </div>
                          <div
                            class="text-overline text-light-grey mb-0"
                            style="
                              font-size: 0.55rem !important;
                              transform: none;
                              letter-spacing: 0;
                              line-height: 1;
                            "
                          >
                            Layanan Publik
                          </div>
                        </div>
                      </v-col>
                      <v-col cols="6" sm="3" class="d-flex align-center py-1">
                        <v-icon color="#018c74" size="20" class="mr-2"
                          >mdi-google-maps</v-icon
                        >
                        <div>
                          <div
                            class="text-caption font-weight-bold primary-text mb-0"
                            style="line-height: 1.2"
                          >
                            Akses Aman
                          </div>
                          <div
                            class="text-overline text-light-grey mb-0"
                            style="
                              font-size: 0.55rem !important;
                              transform: none;
                              letter-spacing: 0;
                              line-height: 1;
                            "
                          >
                            Kondisi Jalan
                          </div>
                        </div>
                      </v-col>
                      <v-col cols="6" sm="3" class="d-flex align-center py-1">
                        <v-icon color="#018c74" size="20" class="mr-2"
                          >mdi-clock-outline</v-icon
                        >
                        <div>
                          <div
                            class="text-caption font-weight-bold primary-text mb-0"
                            style="line-height: 1.2"
                          >
                            Sesuai Jadwal
                          </div>
                          <div
                            class="text-overline text-light-grey mb-0"
                            style="
                              font-size: 0.55rem !important;
                              transform: none;
                              letter-spacing: 0;
                              line-height: 1;
                            "
                          >
                            Jam Operasional
                          </div>
                        </div>
                      </v-col>
                      <v-col cols="6" sm="3" class="d-flex align-center py-1">
                        <v-icon color="#CFA22D" size="20" class="mr-2"
                          >mdi-ticket-percent</v-icon
                        >
                        <div>
                          <div
                            class="text-caption font-weight-bold primary-text mb-0"
                            style="line-height: 1.2"
                          >
                            Terjangkau
                          </div>
                          <div
                            class="text-overline text-light-grey mb-0"
                            style="
                              font-size: 0.55rem !important;
                              transform: none;
                              letter-spacing: 0;
                              line-height: 1;
                            "
                          >
                            Retribusi
                          </div>
                        </div>
                      </v-col>
                    </v-row>
                  </div>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import axios from "axios";
import { getCategories, getSubCategories, getTenants } from "@/api/androidInitApi";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import "leaflet.markercluster";
import "leaflet.markercluster/dist/MarkerCluster.css";
import "leaflet.markercluster/dist/MarkerCluster.Default.css";

export default {
  data: () => ({
    allData: null,
    map: null,
    markerClusterGroup: null,
    activeSubId: null,
    selectedWisataData: null,
    searchQuery: "",
  }),
  computed: {
    currentCategoryName() {
      if (!this.allData?.categories) return "Memuat...";
      const cat = this.allData.categories.find((c) => c.id == this.$route.params.id);
      return cat ? cat.nama_kategori : "Kategori Wisata";
    },
    filteredSub() {
      if (!this.allData?.sub_categories) return [];

      let list = this.allData.sub_categories.filter(
        (s) => s.category_id == this.$route.params.id
      );

      if (this.searchQuery && this.searchQuery.trim() !== "") {
        const query = this.searchQuery.toLowerCase().trim();
        list = list.filter((s) => s.nama_sub.toLowerCase().includes(query));
      }

      return list;
    },
    allTenantsInCategory() {
      if (!this.allData) return [];
      const subIds = this.filteredSub.map((s) => s.id);
      return this.allData.tenants.filter((t) => subIds.includes(t.sub_category_id));
    },
  },
  async mounted() {
    try {
      const [categories, subCategories, tenants] = await Promise.all([
        getCategories(),
        getSubCategories(),
        getTenants(),
      ]);

      this.allData = {
        categories: categories || [],
        sub_categories: subCategories || [],
        tenants: tenants || [],
      };

      if (this.filteredSub.length > 0) {
        this.activeSubId = this.filteredSub[0].id;
        this.selectedWisataData = this.filteredSub[0];
      }

      this.$nextTick(() => this.initMap());
    } catch (e) {
      console.error("API Error", e);
    }
  },
  beforeDestroy() {
    if (this.map) this.map.remove();
  },
  methods: {
    goBack() {
      // Kembali ke halaman sebelumnya; jika tidak ada riwayat
      // (mis. halaman dibuka langsung via link), arahkan ke beranda.
      if (window.history.length > 1) {
        this.$router.back();
      } else {
        this.$router.push("/");
      }
    },
    initMap() {
      if (this.map) {
        this.map.off();
        this.map.remove();
        this.map = null;
      }

      this.map = L.map("map", {
        zoomControl: true,
        attributionControl: false,
        tap: false,
        preferCanvas: true,
      }).setView([-7.9135, 113.8217], 10);

      L.tileLayer("https://tile.openstreetmap.org/{z}/{x}/{y}.png", {
        attribution: "&copy; OpenStreetMap contributors",
      }).addTo(this.map);

      this.markerClusterGroup = L.markerClusterGroup({
        showCoverageOnHover: false,
        zoomToBoundsOnClick: true,
        disableClusteringAtZoom: 16,
      });

      const customIcon = L.divIcon({
        className: "clean-pin-marker",
        html: `<div class="marker-pin-green"><i class="v-icon mdi mdi-map-marker" style="color:#8c1801; font-size: 24px;"></i></div>`,
        iconSize: [30, 30],
        iconAnchor: [15, 30],
        popupAnchor: [0, -30],
      });

      const bounds = [];

      this.allTenantsInCategory.forEach((tenant) => {
        if (tenant.lokasi_map && tenant.lokasi_map.includes(",")) {
          const coords = tenant.lokasi_map
            .split(",")
            .map((num) => parseFloat(num.trim()));

          if (!isNaN(coords[0]) && !isNaN(coords[1])) {
            const marker = L.marker(coords, { icon: customIcon });

            const popupContent = `
              <div class="custom-map-popup">
                <div class="popup-flex">
                  <img src="${
                    this.selectedWisataData?.full_url ||
                    "https://images.unsplash.com/photo-1602002418082-a4443e081dd1"
                  }" class="popup-img" />
                  <div class="popup-info">
                    <h4>${tenant.nama_profil}</h4>
                    <p class="popup-desc">Destinasi pilihan terbaik untuk dikunjungi.</p>
                    <div class="popup-loc"><i class="v-icon mdi mdi-map-marker" style="color:#018c74; font-size:11px;"></i> Bondowoso, Jawa Timur</div>
                  </div>
                </div>
              </div>
            `;

            marker.bindPopup(popupContent, {
              maxWidth: 300,
              className: "clean-leaflet-popup",
            });

            this.markerClusterGroup.addLayer(marker);
            bounds.push(coords);
          }
        }
      });

      this.map.addLayer(this.markerClusterGroup);

      if (bounds.length > 0) {
        this.map.fitBounds(bounds, { padding: [50, 50] });
      }
    },
    selectWisata(sub) {
      this.activeSubId = sub.id;
      this.selectedWisataData = sub;

      const tenant = this.allTenantsInCategory.find((t) => t.sub_category_id === sub.id);
      if (tenant && tenant.lokasi_map && this.map) {
        const coords = tenant.lokasi_map.split(",").map((num) => parseFloat(num.trim()));
        this.map.setView(coords, 13, { animate: true });
      }
    },
    goToTenants(sub) {
      this.$router.push({ name: "tenant_list", params: { sub_id: sub.id } });
    },
  },
};
</script>

<style scoped>
.wisata-app {
  background-color: #f3f7f6 !important;
  height: 100vh !important;
  overflow: hidden !important;
}

.main-header {
  border-bottom: 1px solid #eef2f1 !important;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.02) !important;
  z-index: 100;
}

.back-btn {
  background-color: #f1f5f4 !important;
  transition: background-color 0.2s ease, transform 0.2s ease;
}
.back-btn:hover {
  background-color: rgba(1, 140, 116, 0.12) !important;
  transform: translateX(-2px);
}

.main-content-layout {
  height: calc(100vh - 70px) !important;
  overflow: hidden !important;
}
.fill-height-container {
  height: 100% !important;
  max-height: 100% !important;
}
.fill-height-row {
  height: 100% !important;
}
.fill-column {
  height: 100% !important;
  display: flex;
  flex-direction: column;
}

.sidebar-layout-card,
.map-container-card,
.detail-display-card {
  background-color: #ffffff !important;
  border: 1px solid #e8eceb !important;
  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.02) !important;
}

.sidebar-layout-card {
  height: 100% !important;
  max-height: 100% !important;
  overflow: hidden;
}
.sidebar-scroll-content {
  overflow-y: auto;
}
.sidebar-top-pane {
  background: #ffffff;
}
.sidebar-bottom-pane {
  background: #ffffff;
  border-top: 1px solid #f0f4f3;
}

.wisata-item-card {
  border: 1px solid #e2e8f0 !important;
  background-color: #ffffff !important;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
}
.wisata-item-card:hover {
  border-color: #018c74 !important;
  background-color: #f7faf9 !important;
}
.active-item {
  border: 1.5px solid #018c74 !important;
  background-color: #f0f7f5 !important;
}
.action-route-btn {
  transition: transform 0.2s ease;
}
.action-route-btn:hover {
  transform: scale(1.15);
  background-color: rgba(1, 140, 116, 0.1) !important;
}
.btn-load-more {
  border: 1px solid #e2e8f0 !important;
  font-size: 0.8rem !important;
}

::v-deep .search-field .v-input__control .v-input__slot {
  background-color: #f8fafc !important;
  border-radius: 8px !important;
}

.map-inner-display {
  height: 100%;
  width: 100%;
}

.detail-display-card {
  height: auto;
  min-height: 190px;
}
.detail-preview-img {
  object-fit: cover;
}
.info-paragraph-text {
  line-height: 1.5;
}
.border-top-light {
  border-top: 1px solid #edf2f7;
}

.primary-text {
  color: #1e293b !important;
}
.text-secondary {
  color: #64748b !important;
}
.text-light-grey {
  color: #94a3b8 !important;
}
.white--text {
  color: #ffffff !important;
}

::v-deep .clean-leaflet-popup .leaflet-popup-content-wrapper {
  background: #ffffff;
  border-radius: 12px;
  padding: 2px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
}
::v-deep .clean-leaflet-popup .leaflet-popup-content {
  margin: 6px;
  width: 270px !important;
}
::v-deep .custom-map-popup .popup-flex {
  display: flex;
  align-items: center;
}
::v-deep .custom-map-popup .popup-img {
  width: 75px;
  height: 75px;
  object-fit: cover;
  border-radius: 8px;
  margin-right: 10px;
}
::v-deep .custom-map-popup .popup-info h4 {
  margin: 0 0 2px 0;
  color: #1e293b;
  font-size: 0.85rem;
  font-weight: 700;
}
::v-deep .custom-map-popup .popup-desc {
  margin: 0 0 4px 0;
  font-size: 0.65rem;
  color: #64748b;
  line-height: 1.3;
}
::v-deep .custom-map-popup .popup-loc {
  font-size: 0.65rem;
  font-weight: 600;
  color: #018c74;
}

.sidebar-scroll-content::-webkit-scrollbar {
  width: 4px;
}
.sidebar-scroll-content::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 4px;
}
</style>
